import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { API_BASE_URL } from "../Config";
import { useTranslation } from 'react-i18next';

function PasswordForgot() {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const languageLocale = i18n.language;

      const response = await fetch(`${API_BASE_URL}/api/password_forgot/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email, languageLocale }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.detail || t('email_send_error'));
      } else {
        const data = await response.json();
        setMessage(data.detail || t('email_sent_success'));
        setEmail("");
        setError(null);
      }
    } catch (error) {
      setError(t('email_send_error'));
      console.error(`${t('email_send_error')}:`, error);
    }
  };

  return (
    <Container className="pt-4">
      <Row className="py-lg-3">
        <Col lg={5} md={6} className="align-items-center m-auto">
          <h2 className="h4 mb-4">{t('password_forgot')}</h2>
          <Form onSubmit={handleSubmit} className="p-4 mt-4 mt-md-0 m-auto forms">
            {message && (
              <Alert variant="success" onClose={() => setMessage(null)} dismissible>
                {message}
              </Alert>
            )}
            {error && (
              <Alert variant="danger" onClose={() => setError(null)} dismissible>
                {error}
              </Alert>
            )}
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>{t('email')}</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>    
            <Button variant="primary" type="submit" className="mb-3 me-2" title={t('submit')}>
              {t('submit')}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default PasswordForgot;
